import type { TableDensity } from '../hooks/useTableDensity'

type TableDensityToggleProps = {
  density: TableDensity
  onChange: (density: TableDensity) => void
}

export const TableDensityToggle = ({ density, onChange }: TableDensityToggleProps) => {
  const compact = density === 'compact'
  return (
    <button
      type="button"
      className="echat-btn echat-btn--ghost echat-btn--sm market-density-toggle"
      aria-pressed={compact}
      title="Плотность строк таблицы"
      onClick={() => onChange(compact ? 'standard' : 'compact')}
    >
      {compact ? 'Компактно' : 'Стандартно'}
    </button>
  )
}
